<template>
  <page-with-footer>
    <template v-slot:content>
      <page-header class="default-gutter mb-6"/>
      <page-breadcrumbs/>
      <v-container fluid class="default-gutter" >
        <end-user-license-agreement />
      </v-container>
    </template>
  </page-with-footer>
</template>

<script>
  import PageHeader from "@/components/PageHeader";
  import PageWithFooter from "@/components/PageWithFooter";
  import PageBreadcrumbs from "@/components/PageBreadcrumbs";
  import EndUserLicenseAgreement from "@/components/documents/EndUserLicenseAgreement";

  export default {
    components: {
      EndUserLicenseAgreement,
      PageBreadcrumbs,
      PageWithFooter,
      PageHeader,
    },
    mounted() {
      this.$breadcrumbs.clear();
      this.$breadcrumbs.pushRoute({path: '/'}, 'Home', false);
      this.$breadcrumbs.pushRoute({path: '/end-user-license-agreement'}, 'End User License Agreement', true);
    }
  }
</script>
